
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { SvoiButton, SvoiButtonLink } from '@svoi-ui/components/button'
import BreadCrumbs from '~/components/UI/BreadCrumbs.vue'
import AppLazyImage from '~/components/UI/AppLazyImage.vue'
import { ButtonParams } from '~/model'

export default defineComponent({
  name: 'HeadBanner',
  components: {
    SvoiButton,
    SvoiButtonLink,
    AppLazyImage,
    BreadCrumbs
  },
  props: {
    showBreadCrumbs: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    buttons: {
      type: Array as PropType<ButtonParams[]>,
      default: () => []
    },
    linkCompany: {
      type: String,
      default: ''
    },
    showGradient: {
      type: Boolean,
      default: false
    }
  },
  emits: ['on-click-button-vacancies', 'on-click-button-resume', 'on-click-button-promo'],
  setup(_, { emit }) {
    const handleButtonClick = (eventName: string) => {
      emit(eventName as any)
    }

    return {
      handleButtonClick
    }
  }
})
